import classnames from 'classnames/bind'
import React from 'react'

import Cta, { CtaProps } from '~/components/Cta'
import ImageWithPlaceHolder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'
import Ratio from '~/components/Ratio'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface BoxColumnImageTextProps {
  className?: string
  reversed?: boolean
  horizontal?: boolean
  title?: RichTextBlock[]
  text?: RichTextBlock[]
  primaryCta?: CtaProps
  secondaryCta?: CtaProps
  image?: ImageWithPlaceholderProps
}

function BoxColumnImageText({
  className,
  reversed,
  horizontal,
  title,
  text,
  primaryCta,
  secondaryCta,
  image,
}: BoxColumnImageTextProps) {
  const titleStyle = useStyle({
    textPreset: 'title-section',
  })
  const textStyle = useStyle({
    textPreset: 'rich-text-variant-1',
    color: 'cornflower-blue',
  })

  return (
    <div
      className={cx(css.BoxColumnImageText, className, {
        isReversed: reversed,
        isHorizontal: horizontal,
      })}>
      <div className={css.content}>
        <div className={css.imageWrapper}>
          {image && (
            <Ratio className={css.image} ratio={500 / 245}>
              {(cn) => (
                <ImageWithPlaceHolder
                  layout="fill"
                  objectFit="contain"
                  {...image}
                />
              )}
            </Ratio>
          )}
        </div>
        <div className={css.contentWrapper}>
          {title && (
            <RichText className={cx(css.title, titleStyle)} render={title} />
          )}
          {text && (
            <RichText className={cx(css.text, textStyle)} render={text} />
          )}
          <div className={cx(css.ctas)}>
            {primaryCta && <Cta className={css.cta} {...primaryCta} />}
            {secondaryCta && <Cta className={css.cta} {...secondaryCta} />}
          </div>
        </div>
      </div>
    </div>
  )
}

BoxColumnImageText.defaultProps = {}

export default BoxColumnImageText
